import type { AppConfigMasteryLevelsType } from "@memorang/constants/config/schema";
import { setOpacity } from "@memorang/helpers/setOpacity";
import type { StyleProp, TextStyle, ViewStyle } from "react-native";
import { useAppTheme } from "../../useAppTheme";
import CustomChip from "../CustomChip";

type MasteryLevel = AppConfigMasteryLevelsType[number];

const BACKGROUND_OPACITY = 0.15;

export const getMasteryChipColors = (color: string) => ({
	backgroundColor: setOpacity(color, BACKGROUND_OPACITY),
	textColor: color,
});

export type MasteryChipData = {
	label: string;
	color: string;
};

type Props = {
	label: string;
	color: string;
	style?: StyleProp<ViewStyle>;
	textStyle?: TextStyle;
};

export const MasteryChip = ({ label, color, style, textStyle }: Props) => {
	const { backgroundColor, textColor } = getMasteryChipColors(color);

	return (
		<CustomChip
			style={[{ backgroundColor }, style]}
			textStyle={{ color: textColor, ...textStyle }}
		>
			{label}
		</CustomChip>
	);
};

export const getMasteryLevelColor = (
	masteryLevel: MasteryLevel,
	isDark: boolean,
): string => (isDark ? masteryLevel.darkColor : masteryLevel.lightColor);

export const useMasteryLevelColor = (
	masteryLevel?: MasteryLevel,
): string | undefined => {
	const theme = useAppTheme();
	if (!masteryLevel) {
		return undefined;
	}
	return getMasteryLevelColor(masteryLevel, theme.dark);
};
